var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgZapFast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "zap-fast"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Solid"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6665 12.1669C1.6665 11.7987 1.96498 11.5002 2.33317 11.5002H5.99984C6.36803 11.5002 6.6665 11.7987 6.6665 12.1669C6.6665 12.5351 6.36803 12.8336 5.99984 12.8336H2.33317C1.96498 12.8336 1.6665 12.5351 1.6665 12.1669Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.666504 8.50022C0.666504 8.13203 0.964981 7.83355 1.33317 7.83355H4.33317C4.70136 7.83355 4.99984 8.13203 4.99984 8.50022C4.99984 8.86841 4.70136 9.16688 4.33317 9.16688H1.33317C0.964981 9.16688 0.666504 8.86841 0.666504 8.50022Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.99984 4.83355C1.99984 4.46536 2.29831 4.16689 2.6665 4.16689H5.99984C6.36803 4.16689 6.6665 4.46536 6.6665 4.83355C6.6665 5.20174 6.36803 5.50022 5.99984 5.50022H2.6665C2.29831 5.50022 1.99984 5.20174 1.99984 4.83355Z",
    fill: "currentColor"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.5782 1.88022C11.863 1.99277 12.0345 2.28482 11.994 2.58833L11.428 6.83355H13.9635C13.9711 6.83355 13.9788 6.83355 13.9865 6.83355C14.1336 6.83352 14.2862 6.83348 14.4121 6.845C14.5361 6.85633 14.7616 6.88636 14.9631 7.04192C15.1981 7.22332 15.3404 7.49979 15.3514 7.7965C15.3609 8.05092 15.2542 8.25184 15.1914 8.35928C15.1276 8.46849 15.0389 8.59259 14.9533 8.71232C14.9489 8.71857 14.9444 8.72481 14.9399 8.73104L10.5423 14.8877C10.3644 15.1369 10.0395 15.2328 9.75479 15.1202C9.47003 15.0077 9.29855 14.7156 9.33902 14.4121L9.90505 10.1669H7.36954C7.36189 10.1669 7.35422 10.1669 7.34654 10.1669C7.19938 10.1669 7.04685 10.167 6.92086 10.1554C6.79692 10.1441 6.57145 10.1141 6.36991 9.95852C6.13487 9.77711 5.99259 9.50064 5.98159 9.20394C5.97215 8.94952 6.07877 8.7486 6.14159 8.64116C6.20544 8.53194 6.29412 8.40785 6.37968 8.28812C6.38415 8.28186 6.38861 8.27562 6.39306 8.2694L10.7907 2.11273C10.9687 1.86357 11.2935 1.76767 11.5782 1.88022Z",
    fill: "currentColor"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgZapFast);
export default __webpack_public_path__ + "static/media/zap-fast.322f2de50e14df071a4385c1cfc81584.svg";
export { ForwardRef as ReactComponent };